import { Navigate } from "react-router-dom";
import { UserPreferenceContext } from "../context/UserPreferenceContext";
import { useContext } from "react";

export function PrivateRoute({ children, ...rest }) {
  const { userAuthenticated } = useContext(UserPreferenceContext);
  if (!userAuthenticated) { 
    return <Navigate to="/" />;
  }

    return children;
}